import React, { Fragment } from 'react'
import { Navigate } from 'react-router-dom'
import { withRouter } from 'router'
import { connect } from 'react-redux'
import NProgress from 'nprogress'
import { Helmet } from 'react-helmet'
// import Loader from 'components/cleanui/layout/Loader'
import PublicLayout from './Public'
import AuthLayout from './Auth'
import MainLayout from './Main'
import EmptyLayout from './Empty'

const Layouts = {
  public: PublicLayout,
  auth: AuthLayout,
  main: MainLayout,
  empty: EmptyLayout,
}

const mapStateToProps = ({ user }) => ({ user })
// let previousPath = ''
let previousPathname = ''

const Layout = ({ user, children, location }) => {
  // NProgress & ScrollTop Management
  // const { pathname, search } = location;
  const { pathname } = location

  // const currentPath = pathname + search
  if (previousPathname !== pathname) {
    window.scrollTo(0, 0)
    NProgress.start()
  }
  setTimeout(() => {
    NProgress.done()
    // previousPath = currentPath;
    previousPathname = pathname
  }, 300)

  // Layout Rendering
  const getLayout = () => {
    if (pathname === '/') {
      return 'public'
    }
    if (pathname.indexOf('/downloadFile') === 0) {
      return 'empty'
    }
    if (/^\/auth(?=\/|$)/i.test(pathname)) {
      return 'auth'
    }
    return 'main'
  }

  const Container = Layouts[getLayout()]
  const isUserAuthorized = user.authorized
  const isUserLoading = user.loading
  const isAuthLayout = getLayout() === 'auth'

  const BootstrappedLayout = () => {
    // show loader when user in check authorization process, not authorized yet and not on login pages
    if (isUserLoading && !isUserAuthorized && !isAuthLayout) {
      return null
    }
    // redirect to login page if current is not login page and user not authorized
    if (!isAuthLayout && !isUserAuthorized) {
      return <Navigate to="/auth/login" />
    }
    // in other case render previously set layout
    return <Container>{children}</Container>
  }

  return (
    <Fragment>
      <Helmet titleTemplate="Re:Work Admin | %s" title="Re:Work Admin" />
      {BootstrappedLayout()}
    </Fragment>
  )
}

export default withRouter(connect(mapStateToProps)(Layout))
